/**
 * Formeya mobil drawer — accordion (button + capture), Bettwäsche varsayılan açık.
 */
(function () {
  const BETTWASCHE_ID = 'HeaderDrawer-bettwasche'

  function isBettwasche(li, trigger) {
    if (!trigger) return false
    if (trigger.id === BETTWASCHE_ID) return true
    const text = trigger.querySelector('.menu-drawer__menu-item-text')?.textContent?.trim() ?? ''
    return /^bettw[aä]sche$/i.test(text)
  }

  function setOpen(li, open) {
    li.classList.toggle('fm-nav-accordion--open', open)
    li.classList.toggle('fm-nav-accordion--closed', !open)
    const btn = li.querySelector('.fm-nav-accordion__trigger')
    btn?.setAttribute('aria-expanded', open ? 'true' : 'false')
  }

  function wrapAccordionHeader(li, anchor) {
    const existing = li.querySelector(':scope > .fm-nav-accordion__trigger')
    if (existing) return existing

    const btn = document.createElement('button')
    btn.type = 'button'
    btn.className =
      'menu-drawer__menu-item menu-drawer__menu-item--mainlist fm-nav-accordion__trigger focus-inset'
    if (anchor.id) {
      btn.id = anchor.id
      anchor.removeAttribute('id')
    }

    const panel = li.querySelector(':scope > .menu-drawer__menu--childlist')
    if (panel) {
      if (!panel.id) panel.id = `fm-nav-panel-${btn.id || Math.random().toString(36).slice(2, 9)}`
      btn.setAttribute('aria-controls', panel.id)
    }

    const textSpan = anchor.querySelector('.menu-drawer__menu-item-text')
    if (textSpan) btn.appendChild(textSpan.cloneNode(true))
    else btn.textContent = anchor.textContent?.trim() ?? ''

    const href = anchor.getAttribute('href') || ''
    if (href) btn.dataset.fmNavHref = href

    anchor.replaceWith(btn)
    return btn
  }

  function enhanceNav(nav) {
    if (!nav) return

    nav.querySelectorAll('.menu-drawer__list-item--flat').forEach((li) => {
      if (li.dataset.fmNavEnhanced === '1') return
      const childlist = li.querySelector(':scope > .menu-drawer__menu--childlist')
      const anchor = li.querySelector(':scope > a.menu-drawer__menu-item--mainlist')
      if (!childlist || !anchor) return

      li.dataset.fmNavEnhanced = '1'
      li.classList.add('fm-nav-accordion')
      const btn = wrapAccordionHeader(li, anchor)
      setOpen(li, isBettwasche(li, btn))
    })
  }

  function blockParentNav(event) {
    const anchor = event.target.closest('a.menu-drawer__menu-item--mainlist')
    if (!anchor) return
    const li = anchor.closest('.menu-drawer__list-item--flat')
    if (!li?.querySelector(':scope > .menu-drawer__menu--childlist')) return
    event.preventDefault()
  }

  function handleToggle(event) {
    if (event.type !== 'click') return
    const nav = event.target.closest('.menu-drawer__navigation')
    if (!nav) return

    let btn = event.target.closest('.fm-nav-accordion__trigger')
    if (!btn) {
      const anchor = event.target.closest('a.menu-drawer__menu-item--mainlist')
      if (!anchor) return
      const li = anchor.closest('.menu-drawer__list-item--flat')
      if (!li?.querySelector(':scope > .menu-drawer__menu--childlist')) return
      enhanceNav(nav)
      btn = li.querySelector('.fm-nav-accordion__trigger')
      if (!btn) return
    }

    const li = btn.closest('.fm-nav-accordion')
    if (!li || !nav) return

    event.preventDefault()
    event.stopPropagation()
    event.stopImmediatePropagation()

    const willOpen = !li.classList.contains('fm-nav-accordion--open')
    setOpen(li, willOpen)

    if (willOpen) {
      nav.querySelectorAll('.fm-nav-accordion').forEach((other) => {
        if (other === li) return
        const otherBtn = other.querySelector('.fm-nav-accordion__trigger')
        if (isBettwasche(other, otherBtn)) return
        setOpen(other, false)
      })
    }
  }

  function openBettwascheOnDrawer() {
    document.querySelectorAll('.menu-drawer__navigation').forEach((nav) => {
      nav.querySelectorAll('.fm-nav-accordion').forEach((li) => {
        const btn = li.querySelector('.fm-nav-accordion__trigger')
        if (isBettwasche(li, btn)) setOpen(li, true)
      })
    })
  }

  function boot() {
    document.querySelectorAll('.menu-drawer__navigation').forEach(enhanceNav)

    const drawer = document.getElementById('Details-menu-drawer-container')
    if (drawer && !drawer.dataset.fmNavToggle) {
      drawer.dataset.fmNavToggle = '1'
      drawer.addEventListener('toggle', () => {
        if (drawer.open) {
          document.querySelectorAll('.menu-drawer__navigation').forEach(enhanceNav)
          openBettwascheOnDrawer()
        }
      })
    }
  }

  document.addEventListener('pointerdown', blockParentNav, true)
  document.addEventListener('click', handleToggle, true)

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot)
  } else {
    boot()
  }

  new MutationObserver(boot).observe(document.documentElement, { childList: true, subtree: true })
})()
